/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/assets-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/assets-api-client";
import type { AssetsAPIUploadUploadMutationRequest, AssetsAPIUploadUploadMutationResponse } from "../models/AssetsAPIUploadUpload";

function getAssetsAPIUploadUploadUrl() {
  const res = { method: 'POST', url: `/assets` as const }  
  return res
}

/**
 * @summary Upload asset
 * {@link /assets}
 */
export async function assetsAPIUploadUpload(data: AssetsAPIUploadUploadMutationRequest, config: Partial<RequestConfig<AssetsAPIUploadUploadMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = new FormData()
  if (requestData) {
   Object.keys(requestData).forEach((key) => {
     const value = requestData[key as keyof typeof requestData];
     if (typeof value === 'string' || (value as unknown) instanceof Blob) {
       formData.append(key, value as unknown as string | Blob);
     }
   })
  }  
  const res = await request<AssetsAPIUploadUploadMutationResponse, ResponseErrorConfig<Error>, AssetsAPIUploadUploadMutationRequest>({ method : "POST", url : getAssetsAPIUploadUploadUrl().url.toString(), data : formData, ... requestConfig, headers : { 'Content-Type': 'multipart/form-data', ...requestConfig.headers } })  
  return res.data
}